import CategoryButton from '../CategoryButton/CategoryButton';
import './CategoryGroup.css';

const CategoryGroup = ({categoryGroup, selected, setSelected}) => {

    const color = categoryGroup.color ? categoryGroup.color : "white";
    const hoverColor = categoryGroup.hoverColor ? categoryGroup.hoverColor : "rgb(255, 255, 255, 0.6)";
    const selectedColor = categoryGroup.selectedColor ? categoryGroup.selectedColor : "rgb(255, 255, 255, 0.7)";

    return (
        <div style={{color: color}}>
            { categoryGroup.title &&
                <div className={`categoryGroupTitle`}>
                    <div className={`categoryLine`} style={{background: color}}/>
                        {categoryGroup.icon}
                        {categoryGroup.title}
                    <div className={`categoryLine`} style={{background: color}}/>
                </div>
            }

            <div className='mb-4'>
                { categoryGroup.buttons.map(categoryButton => 
                    <CategoryButton 
                        categoryButton={categoryButton} 
                        color={color} 
                        hoverColor={hoverColor}
                        selected={selected}
                        setSelected={setSelected}
                        selectedColor={selectedColor}
                    />
                )}
            </div>
        </div>
    )
}

export default CategoryGroup;